import React, { useEffect, useState } from 'react'
import EmailInputRecipient from '../../../common/components/EmailInputRecipient'
import GeneralTextInput from '../../../common/components/GeneralTextInput/generalTextInput'
import Radio from '../../../common/components/SimpleInputs/Radio'
import LookupList from '../LookupsList/LookupList'
import { Recipient } from '../../../common/types/form'
import getLookups from '../../../api/getLookups'
import getLookupValues from '../../../api/getLookupValues'
import { recipientGroupSingleValidations } from '../../validations'
import styled from 'styled-components'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../../../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

import LiveModal from 'live/components/ui/Modal'
import { LookupListDataModel } from 'plugin-reports-maker/webapp/js/common/types/utilities'

interface ModalRecipientGroupProps {
    recipientGroup?: Recipient
    showingModal: boolean
    isNew?: boolean
    onClose: (cancel: boolean) => void
    onSave: (recipient: Recipient) => void
}

export function ModalRecipientGroup({
    recipientGroup,
    showingModal,
    isNew,
    onClose,
    onSave
}: ModalRecipientGroupProps): JSX.Element {
    const [recipient, setRecipient] = useState<Recipient>(
        isNew
            ? ({ enabled: false, lookups: { '': [] } as LookupListDataModel, name: '', recipients: [] } as Recipient)
            : { ...recipientGroup }
    )

    const [validations, setValidations] = useState<string[]>([])

    useEffect(() => {
        setValidations(recipientGroupSingleValidations(recipient))
    }, [recipient])

    useEffect(() => {
        setRecipient({ ...recipientGroup })
    }, [recipientGroup])

    return (
        <StyledLiveModal show={showingModal} onHide={() => onClose(false)} animation={false} className="modal-sm">
            <StyledLiveModal.Header>
                <StyledLiveModal.Title>
                    {i18n(`Group of people: ${recipient.name ? recipient.name : ''}`)}
                </StyledLiveModal.Title>
            </StyledLiveModal.Header>
            <StyledLiveModal.Body>
                <StyledRecipientGroup className="recipientGroup">
                    <div tabIndex={0} className={`recipientGroup--container`}>
                        <div className={`recipientGroup--container__nameStatus`}>
                            <GeneralTextInput
                                variant={'primary'}
                                border={true}
                                title={i18n('Group Name')}
                                error={false}
                                editMode={true}
                                placeholder={i18n('Name of the group')}
                                required={true}
                                value={recipient.name}
                                onChange={name => {
                                    const newRecipient = { ...recipient }
                                    newRecipient.name = name
                                    setRecipient({ ...newRecipient })
                                }}
                            />
                            <Radio
                                editMode={true}
                                required={true}
                                title={i18n('Group Status')}
                                onChange={value => {
                                    const newRecipient = { ...recipient }
                                    newRecipient.enabled = value
                                    setRecipient({ ...newRecipient })
                                }}
                                value={recipient.enabled}
                            />
                        </div>
                        <div className={`recipientGroup--container__emailsInput`}>
                            <EmailInputRecipient
                                title={i18n('Recipients')}
                                variant={'primary'}
                                bottomText={i18n('Type the recipients with commas "," or spaces " " at the end')}
                                required={true}
                                editMode={true}
                                onChange={emailRecipients => {
                                    const newRecipient = { ...recipient }
                                    newRecipient.recipients = emailRecipients
                                    setRecipient({ ...newRecipient })
                                }}
                                values={recipient.recipients}
                            />
                        </div>
                        <div className={`recipientGroup--container__lookupsList`}>
                            <LookupList
                                getLookup={getLookups}
                                getLookupValues={getLookupValues}
                                lookupData={recipient.lookups}
                                handleLookup={lookups => {
                                    const newRecipient = { ...recipient }

                                    if (!Object.entries(lookups).length) {
                                        newRecipient.lookups = { '': [] }
                                    } else {
                                        newRecipient.lookups = lookups
                                    }

                                    setRecipient({ ...newRecipient })
                                }}
                                editMode={true}
                            />
                        </div>
                    </div>
                </StyledRecipientGroup>
            </StyledLiveModal.Body>
            <StyledLiveModal.Footer>
                <StyledLiveModal.ModalActions
                    onSubmit={() => {
                        if (!validations.length) {
                            onSave(recipient)
                            GlobalNotification.success(
                                <Notification title={i18n('Success adding new recipient group')} />,
                                3
                            )

                            if (isNew) {
                                setRecipient({
                                    uuid: undefined,
                                    enabled: false,
                                    lookups: { '': [] },
                                    name: '',
                                    recipients: []
                                })
                            }
                            onClose(false)
                        } else {
                            GlobalNotification.error(
                                <Notification title={i18n('Before saving, you need to fix the following issues: ')}>
                                    {i18n('The following entered fields are invalid: ')}
                                    {validations.map((value, index) => (
                                        <tr key={index}>{value}</tr>
                                    ))}
                                </Notification>,
                                3
                            )
                        }
                    }}
                    submitText={i18n('Save')}
                    submitBtnClassName="btn btn-primary"
                    cancelBtnClassName={null}
                    onCancel={() => {
                        onClose(false)
                    }}
                    cancelText={i18n('Cancel')}
                />
            </StyledLiveModal.Footer>
        </StyledLiveModal>
    )
}

const StyledLiveModal = styled(LiveModal)`
    .modal-dialog {
        width: 950px;
    }
    .modal-body {
        //height: 500px;
        //max-height: 900px;
    }
`

const StyledRecipientGroup = styled.div`
    .recipientGroup {
        &--container {
            display: flex;
            flex-direction: column;
            background-color: transparent;
            padding: 10px;
            &__nameStatus {
                display: flex;
                > div {
                    flex: 1;
                    &:first-child {
                        margin-right: 10px;
                    }
                }
            }
            &__emailsInput {
                margin-bottom: 10px;
            }

            &__text {
                font-size: 15px;
                margin-top: 14px;
            }
        }
    }
`
